import type { AdminUserActivity } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatCount } from '@/shared/lib';
import { ContentCard } from '@/shared/ui';

interface UserActivityCardProps {
  readonly activity: AdminUserActivity;
}

/** 활동 카드 — 그 회원이 만든 디자인·견적 요청·주문 건수(상태 무관). */
export const UserActivityCard = ({ activity }: UserActivityCardProps): ReactElement => {
  const items = [
    { label: '디자인', count: activity.designCount, unit: '개' },
    { label: '견적 요청', count: activity.quoteRequestCount, unit: '건' },
    { label: '주문', count: activity.orderCount, unit: '건' },
  ];

  return (
    <ContentCard title="활동">
      <dl className="grid grid-cols-3 gap-3">
        {items.map((item) => (
          <div key={item.label} className="flex min-w-0 flex-col gap-1">
            <dt className="text-sm text-muted-foreground">{item.label}</dt>
            <dd className="text-2xl font-semibold tabular-nums tracking-[-0.02em]">
              {formatCount(item.count)}
              <span className="ml-0.5 text-sm font-medium">{item.unit}</span>
            </dd>
          </div>
        ))}
      </dl>
    </ContentCard>
  );
};
